// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nrxt[data-v-02d024e1]{font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp": "nrxt"
};
module.exports = ___CSS_LOADER_EXPORT___;
